import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RotateRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rotate_right"}/>
}
